import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IListing, IListingsResponse, ListingsService } from '@out-web/core';
import { ListingCardComponent } from '../../listing-card/listing-card.component';
import { ListingSkeletonComponent } from '../../../molecules/listing-skeleton/listing-skeleton.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'out-similar-listing',
  imports: [ListingCardComponent, CommonModule, ListingSkeletonComponent, RouterLink],
  templateUrl: './similar-listing.component.html',
  styleUrl: './similar-listing.component.scss',
})
export class SimilarListingComponent implements  OnChanges {
  @Input() listingModel!: string | undefined;
  @Input() listingID: string | undefined;
  placeholders = Array(3).fill(0);
  placeholderSkeletons = Array(3).fill(0);

  listings: IListing[] = [];
  isLoading = true;
  noListingsMessage = '';
  model = '';

  // Track last loaded values to avoid duplicate loads
  public previousModel: string | undefined;
  private previousID: string | undefined;

  constructor(private listingsService: ListingsService) {}

  // ngOnInit() {
  //   this.loadListings();
  // }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['listingModel'] && changes['listingModel'].currentValue) {
  //     this.loadListings();
  //   }

  //   if (changes['listingID'] && changes['listingID'].currentValue) {
  //     this.loadListings();
  //   }
  // }

  ngOnChanges(changes: SimpleChanges): void {
    const modelChanged = changes['listingModel'] && changes['listingModel'].currentValue !== this.previousModel;
    const idChanged = changes['listingID'] && changes['listingID'].currentValue !== this.previousID;

    if ((modelChanged || idChanged) && this.listingModel && this.listingID) {
      this.isLoading = true; // Show skeleton immediately
      this.loadListings();
    }
  }

  // loadListings() {

  //   this.listingsService
  //     .fetchListings(
  //       { listingType: '!Sold', 'vehicle.model': this.listingModel ?? '' },
  //       'category',
  //       true
  //     )
  //     .subscribe({
  //       next: (data: IListingsResponse) => {
  //         this.listings = data.listings
  //           .filter((listing) => listing.shortId !== this.listingID)
  //           .slice(0, 3);
            
  //           // Check if listings are empty
  //           if (this.listings.length === 0) {
  //             this.noListingsMessage = 'There are currently no listings.';
  //           } else {
  //             this.noListingsMessage = ''; // Clear the message if listings are available
  //         }
  //         this.isLoading = true;
  //       },
  //       error: (error) => {
  //         console.error('Error fetching listings', error);
  //         this.isLoading = false;
  //       },
  //       complete: () => {
  //         this.isLoading = false;
  //       },
  //     });
  // }

  private loadListings(): void {
    this.listingsService
      .fetchListings(
        { listingType: '!Sold', 'vehicle.model': this.listingModel ?? '' },
        'category',
        true
      )
      .subscribe({
        next: (data: IListingsResponse) => {
          this.listings = data.listings
            .filter((listing) => listing.shortId !== this.listingID)
            .slice(0, 3);

          this.noListingsMessage = this.listings.length === 0
            ? 'There are currently no listings.'
            : '';

          // Save current values to compare in future updates
          this.previousModel = this.listingModel;
          this.previousID = this.listingID;

          console.log("Listings loaded successfully", this.listings);
        },
        error: (error) => {
          console.error('Error fetching listings', error);
          this.noListingsMessage = 'Failed to load listings.';
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

}
